module.exports = __webpack_public_path__ + "img/rope-sealant-joint-replacement.a4c572f8.jpg";